import Alert from "../icons/alert";

const InfoNote = ({ message }: { message: string }) => {
	return (
		<p className="mb-4 flex gap-1 text-xs">
			<Alert size="xs" />
			{message}
		</p>
	);
};

export default InfoNote;
